import { useState, useEffect, createContext, useContext } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BookingLinksContext = createContext({});

export const BookingLinksProvider = ({ children }) => {
  const [links, setLinks] = useState({ general: "" });

  useEffect(() => {
    axios.get(`${API}/booking-links`).then(res => setLinks(res.data)).catch(() => {});
  }, []);

  return (
    <BookingLinksContext.Provider value={links}>
      {children}
    </BookingLinksContext.Provider>
  );
};

export const useBookingLinks = () => useContext(BookingLinksContext);

/** Get the booking URL for a class type, falling back to general */
export const getBookingUrl = (links, classType) => {
  if (classType && links[classType]) return links[classType];
  return links.general || "";
};
